import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home').then((m) => m.HomePage),
  },
  {
    path: 'quienes-somos',
    loadComponent: () => import('./pages/company/quienes-somos/quienes-somos').then((m) => m.QuienesSomos),
  },
  {
    path: 'complementos',
    loadComponent: () => import('./pages/complementos/complementos').then((m) => m.Complementos),
  },
  {
    path: 'contacto',
    loadComponent: () => import('./pages/contacto/contacto').then((m) => m.ContactoPage),
  },
  {
    path: 'blog',
    loadComponent: () => import('./pages/blog/home/home').then((m) => m.BlogPage),
  },
  {
    path: 'blog/:slugPost',
    loadComponent: () => import('./pages/blog/detail/detail').then((m) => m.BlogPostPage),
  },
  {
    path: 'mack-financial-services',
    loadComponent: () =>
      import('./pages/mack-financial-services/mack-financial-services').then(
        (m) => m.MackFinancialServicesPage,
      ),
  },
  {
    path: 'camiones',
    loadComponent: () => import('./pages/trucks/home/home').then((m) => m.CamionesPage),
  },
  {
    path: 'camiones/:slugTruck',
    loadComponent: () => import('./pages/trucks/detail/detail').then((m) => m.CamionDetallePage),
  },
  {
    path: 'servicio',
    loadComponent: () => import('./pages/service/home/home').then((m) => m.ServicioPage),
  },
  {
    path: 'servicio/:slugCategory',
    loadComponent: () =>
      import('./pages/service/category/category').then((m) => m.CategoriaServicioPage),
  },
  {
    path: 'servicio/:slugCategory/:slugService',
    loadComponent: () =>
      import('./pages/service/detail/detail').then((m) => m.ServicioDetallePage),
  },
  {
    path: 'programas-integrales',
    loadComponent: () =>
      import('./pages/comprehensive-programs/home/home').then(
        (m) => m.ProgramasIntegralesPage,
      ),
  },
  {
    path: 'programas-integrales/:slugPrograma',
    loadComponent: () =>
      import('./pages/comprehensive-programs/detail/detail').then((m) => m.ProgramaDetallePage),
  },
  {
    path: 'industrias',
    loadComponent: () => import('./pages/industries/home/home').then((m) => m.IndustriasPage),
  },
  {
    path: 'industrias/:slugIndustry',
    loadComponent: () =>
      import('./pages/industries/detail/detail').then((m) => m.IndustriaDetallePage),
  },
  {
    path: 'sucursales',
    loadComponent: () => import('./pages/branches/home/home').then((m) => m.SucursalesPage),
  },
  {
    path: 'sucursales/:slugSucursal',
    loadComponent: () =>
      import('./pages/branches/detail/detail').then((m) => m.DetalleSucursalPage),
  },
  {
    path: 'legales/:slugLegal',
    loadComponent: () =>
      import('./pages/company/legals/legals').then((m) => m.LegalDetallePage),
  },
  {
    path: 'eventos/:slugEvento',
    loadComponent: () => import('./pages/events/detail/detail').then((m) => m.EventoDetallePage),
  },
  {
    path: 'gracias/:slugDeDondeViene',
    loadComponent: () => import('./pages/gracias/gracias').then((m) => m.GraciasPage),
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found').then((m) => m.NotFoundPage),
  },
];
